import type { Country } from '@skippay/core/@types/country';

export const migrations = {
	0: (state) => {
		return {
			...state,
			user: {
				...state.user,
				country: state.user.country ?? ('CZ' as Country),
			},
		};
	},
};
